import { AlertTriangle, ArrowRight, GitFork, Quote, Scale, Waypoints } from "lucide-react";
import { assessmentForClaim, claimsForEvent } from "../researchData";
import type { EventRecord } from "../types";

export function ClaimProvenance({ event }: { event: EventRecord }) {
  const eventClaims = claimsForEvent(event.id);

  return (
    <section className="claims-section" id="claims">
      <div className="section-heading claims-heading">
        <div>
          <h2>Claim provenance</h2>
          <p>{event.label}</p>
        </div>
        <span className="section-count">WHY, NOT ONLY WHAT</span>
      </div>
      <div className="claim-stack">
        {eventClaims.map((claim) => {
          const assessment = assessmentForClaim(claim.id);
          const label = assessment?.label ?? "unknown";
          return (
            <article className="claim-record" key={claim.id}>
              <div className="claim-statement">
                <Quote size={18} />
                <div>
                  <span>Atomic proposition</span>
                  <h3>{claim.proposition}</h3>
                </div>
              </div>
              <div className="claim-confidence">
                <span>Preliminary confidence</span>
                <b className={`confidence-${label}`}>{label.replace("_", " ")}</b>
              </div>
              <div className="claim-rationale">
                <Scale size={18} />
                <div><span>Reasoning</span><p>{assessment?.rationale ?? claim.confidence.rationale}</p></div>
              </div>
              <div className="claim-route">
                <Waypoints size={18} />
                <div>
                  <span>Independent families</span>
                  <p>{assessment?.independent_families.length ? assessment.independent_families.map((item) => item.replace("source-family.", "").replaceAll("-", " ")).join(" · ") : "None established"}</p>
                </div>
              </div>
              {assessment?.dependent_displays?.length ? (
                <div className="claim-warning">
                  <GitFork size={17} />
                  <p>Displayed again through a dependent route: {assessment.dependent_displays.join(", ")}. This adds no independence weight.</p>
                </div>
              ) : null}
              <div className="claim-next">
                <AlertTriangle size={17} />
                <p><span>What could change the judgment</span>{assessment?.remaining_work ?? "Further source collation."}</p>
                <ArrowRight size={18} />
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
